import { useEffect } from 'react';
import { useSceneHandler } from 'contexts/sceneHandler';
import { useHistory, useLocation } from 'react-router-dom';
import { AppRoutes } from 'routes';
import { DesignSourceEnum } from '@insights/insights-data-provider';
import { getVpcSource } from 'analytics-api/insights/utils';
import { getQuery } from 'utils/queryUtils';

const LoadConfigFromVpc = ({ match }: any) => {
  const vpcCode = match.params.vpcCode || '';
  const history = useHistory();
  const { loadVpcScene } = useSceneHandler();
  const location = useLocation();

  useEffect(() => {
    const { sourceValue, validSource } = getVpcSource(getQuery(location.search));
    const source = validSource ? sourceValue : DesignSourceEnum.clipboard;

    loadVpcScene(vpcCode, source)
      .then(scene => scene?.init())
      .then(scene => {
        if (scene?.initialized) {
          history.replace(AppRoutes.PLANNER);
        } else if (scene?.legacy) {
          history.replace(AppRoutes.SUMMARY);
        } else {
          return Promise.reject();
        }
      })
      .catch(() => {
        history.replace(AppRoutes.HOME);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default LoadConfigFromVpc;
